import { Card, CardContent, Chip, Divider, Stack, Typography } from "@mui/material"
import { useState } from "react"
import { If } from "lib/@components/if"
import { ProjectBridgeCanonicalStatusChip } from "./project-bridge-canonical-status-chip"
import { ProjectBridgeRewriteCardCurrentPane } from "./project-bridge-rewrite-card-current-pane"
import { ProjectBridgeRewriteCardProposedPane } from "./project-bridge-rewrite-card-proposed-pane"
import {
    getProjectBridgeCanonicalPropagationStatusColor,
    getProjectBridgeCanonicalPropagationStatusLabel,
    getProjectBridgeRewriteCardTitle,
} from "./project-bridge-rewrite-card-presenters"

export function ProjectBridgeRewriteCard({
    item,
    onDecisionChange,
    onTextChange,
    onCriticalityChange,
    onCanonicalPropagationAction,
}) {
    const [editing, setEditing] = useState(false)
    const title = getProjectBridgeRewriteCardTitle(item)
    const canonicalPropagationStatusLabel = getProjectBridgeCanonicalPropagationStatusLabel(item)
    const canonicalPropagationStatusColor = getProjectBridgeCanonicalPropagationStatusColor(item)

    return (
        <Card variant="outlined">
            <CardContent>
                <Stack spacing={2}>
                    <Stack direction="row" justifyContent="space-between" spacing={2} alignItems="center">
                        <Typography variant="h6">{title}</Typography>
                        <Stack direction="row" spacing={1.5} alignItems="center">
                            <ProjectBridgeCanonicalStatusChip item={item} />
                            <If truthy={canonicalPropagationStatusLabel}>
                                <Chip
                                    size="small"
                                    label={canonicalPropagationStatusLabel}
                                    color={canonicalPropagationStatusColor}
                                    variant="outlined"
                                />
                            </If>
                            <Typography variant="body2" color="text.secondary">
                                {getOverlapLabel(item)}
                            </Typography>
                            <If truthy={resolveCardStateLabel(item)}>
                                <Typography variant="body2" color="warning.main">
                                    {resolveCardStateLabel(item)}
                                </Typography>
                            </If>
                        </Stack>
                    </Stack>

                    <Stack direction="row" spacing={2} divider={<Divider flexItem orientation="vertical" />}>
                        <Stack sx={{ flex: 1, minWidth: 0 }}>
                            <ProjectBridgeRewriteCardCurrentPane item={item} />
                        </Stack>
                        <Stack sx={{ flex: 1, minWidth: 0 }}>
                            <ProjectBridgeRewriteCardProposedPane
                                item={item}
                                editing={editing}
                                onStartEdit={startEdit}
                                onCancelEdit={cancelEdit}
                                onSaveText={handleSaveText}
                                onDecisionChange={onDecisionChange}
                                onCriticalityChange={onCriticalityChange}
                                onCanonicalPropagationAction={onCanonicalPropagationAction}
                            />
                        </Stack>
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    )

    function startEdit() {
        setEditing(true)
    }

    function cancelEdit() {
        setEditing(false)
    }

    function handleSaveText(newText, editScope) {
        setEditing(false)
        if (!item?.changeId) return
        onTextChange?.(item.changeId, newText, editScope)
    }
}

function resolveCardStateLabel(item) {
    if (!item?.hasRewrite && item?.mappingStatus === "unresolved") return "Mapping unresolved"
    return ""
}

function getOverlapLabel(item) {
    const overlapCount = Number(item?.overlapCount || 0)
    if (overlapCount === 1) return "1 overlap"
    return `${overlapCount} overlaps`
}
